export const jessup = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 25,
  inputPaddingInline: 10,

  inputHeight: 50,
  inputWidth: '287',
  inputWidthUnits: "px",

  inputFontSize: 13,
  inputFontFamily: '"Open Sans", sans-serif',
  inputColor: "#515E59",
  inputBackgroundColor: "#ffffff",
  inputFontWeight: 400,

  inputBorderColor: "#D8DDE6",
  inputBorderWidth: 1,
  inputBorderRadius: 1,

  inputHoverColor: "#515E59",
  inputHoverBorderColor: "#D8DDE6",
  inputHoverBackgroundColor: "#ffffff",

  // **********************************
  //  Select field
  selectTopSpacing: 25,
  selectPaddingInline: 10,

  selectHeight: 50,
  selectWidth: '133',
  selectWidthUnits: "px",

  selectFontSize: 13,
  selectFontFamily: '"Open Sans", sans-serif',
  selectColor: "#515E59",
  selectBackgroundColor: "#F0F0F0",
  selectFontWeight: 400,

  selectBorderColor: "transparent",
  selectBorderWidth: 1,
  selectBorderRadius: 1,

  selectHoverColor: "transparent",
  selectHoverBorderColor: "#D8DDE6",
  selectHoverBackgroundColor: "#F0F0F0",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 25,
  textAreaPaddingInline: 10,

  textAreaHeight: 50,
  textAreaWidth: '287',
  textAreaWidthUnits: "px",

  textAreaFontSize: 13,
  textAreaFontFamily: '"Open Sans", sans-serif',
  textAreaColor: "#515E59",
  textAreaBackgroundColor: "#ffffff",
  textAreaFontWeight: 400,

  textAreaBorderColor: "#D8DDE6",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 1,

  textAreaHoverColor: "#515E59",
  textAreaHoverBorderColor: "#D8DDE6",
  textAreaHoverBackgroundColor: "#ffffff",

  // **********************************
  //  placeholder
  placeholderColor: "#515E59",
  placeholderFontFamily: '"Open Sans", sans-serif',
  placeholderFontSize: 13,
  placeholderFontWeight: 400,
  placeholderHoverColor: "#515E59",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 9,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 13,
  fieldLabelColor: "#515E59",
  fieldLabelFontWeight: 400,
  fieldLabelColorAsterisk: "#790000",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Open Sans", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#515E59",
  descriptionFontSize: 14,
  descriptionFontWeight: 400,
  descriptionFontFamily: '"Open Sans", sans-serif',
  descriptionTopSpacing: 10,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 12,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 1,
  checkboxUncheckedBorderColor: "#000000",
  checkboxUncheckedBackgroundColor: "#ffffff",
  checkboxCheckedBackgroundColor: "#5F8FDC",
  checkboxCheckedBorderColor: "#000000",
  checkboxCheckedColor: "#ffffff",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Open Sans", sans-serif',
  checkboxLabelFontSize: 14,
  checkboxLabelFontWeight: 400,
  checkboxLabelColor: "#515E59",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 12,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#000000",
  radioUncheckedBackgroundColor: "#ffffff",
  radioCheckedBackgroundColor: "#5F8FDC",
  radioCheckedBorderColor: "#EBEBEB",

  radioAlignment: "none",

  radioLabelFontFamily: '"Open Sans", sans-serif',
  radioLabelFontSize: 14,
  radioLabelFontWeight: 400,
  radioLabelColor: "#515E59",

  // **********************************
  // submit button

  submitMarginTop: 55,
  submitFontSize: 13,
  submitFontFamily: "'Open Sans', sans-serif",
  submitWidth: 70,
  submitWidthUnits: "px",
  submitHeight: 30,
  submitBorderRadius: 0,
  submitBorderWidth: 1,
  submitBackground: "#ffffff",
  submitColor: "#5F8FDC",
  submitBorderColor: "#EFEFEF",
  submitBackgroundHover: "#ffffff",
  submitBorderColorHover: "#EFEFEF",
  submitColorHover: "#5F8FDC",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 400,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "left",
};

  